import React, { PropsWithChildren } from 'react';

/**
 * Table Header Slot
 */
export default function Head({ children }: PropsWithChildren<{}>) {
  return <>{children}</>;
}
